// extracted by mini-css-extract-plugin
module.exports = {"modalOverlay":"mx-z","modalContent":"nx-z","header":"ox-z","close":"px-z"};